import { render, staticRenderFns } from "./goodsEdit.vue?vue&type=template&id=6dbddb4b&scoped=true"
import script from "./goodsEdit.vue?vue&type=script&lang=js"
export * from "./goodsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbddb4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dbddb4b')) {
      api.createRecord('6dbddb4b', component.options)
    } else {
      api.reload('6dbddb4b', component.options)
    }
    module.hot.accept("./goodsEdit.vue?vue&type=template&id=6dbddb4b&scoped=true", function () {
      api.rerender('6dbddb4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/condom/goodsEdit.vue"
export default component.exports